export const WINDOW_INJECTION_TOKEN = 'Window';
